/**
 * Complete the Bundle — always-expanded widget.
 * Panel, add button and savings are always visible (no toggle).
 * Partner color -> size cascade with live price split. Real discount applied
 * at checkout by a native Shopify automatic discount.
 */
(function () {
  if (customElements.get('bundle-widget')) return;

  function money(cents) {
    try {
      if (typeof window.formatPrice === 'function' && window.theme && window.theme.settings) {
        return window.formatPrice(cents, window.theme.settings.money_format);
      }
    } catch (e) {}
    return 'Dhs. ' + (cents / 100).toFixed(2);
  }

  class BundleWidget extends HTMLElement {
    connectedCallback() {
      this.shirtPrice = parseInt(this.getAttribute('data-shirt-price') || '0', 10);
      this.dealCents = parseInt(this.getAttribute('data-deal-cents') || '0', 10);
      try { var d = this.querySelector('[data-partner-data]'); this.partnerData = d ? JSON.parse(d.textContent) : []; }
      catch (e) { this.partnerData = []; }

      this.panel = this.querySelector('[data-bundle-panel]');
      this.addBtn = this.querySelector('[data-add]');
      this.errorEl = this.querySelector('.ctb__error');
      this.currentSize = this.querySelector('[data-current-size]');
      this.colorSelect = this.querySelector('[data-partner-color]');
      this.sizeSelect = this.querySelector('[data-partner-size]');
      this.partnerThumb = this.querySelector('[data-partner-thumb]');
      this.partnerName = this.querySelector('[data-partner-name]');
      this.saveEl = this.querySelector('[data-bundle-save]');
      this.wasEl = this.querySelector('[data-bundle-was]');

      if (this.colorSelect) { this.colorSelect.addEventListener('change', this.onColorChange.bind(this)); this.onColorChange(); }
      if (this.addBtn) this.addBtn.addEventListener('click', this.onAdd.bind(this));

      // Route through the main Add-to-cart button when the product page has one.
      this.coordinated = !!(document.querySelector('product-form') && window.OfferCoordinator);
      this.head = this.querySelector('[data-ctb-head]');
      this.offer = {
        label: this.offerLabel.bind(this),
        submit: this.onAdd.bind(this),
        deselect: this.deselectBundle.bind(this)
      };
      if (this.coordinated) {
        if (this.addBtn) this.addBtn.style.display = 'none';
        this.classList.remove('is-selected'); // unselected by default
        if (this.head) {
          this.head.addEventListener('click', this.onToggle.bind(this));
          this.head.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onToggle(); }
          }.bind(this));
        }
        window.OfferCoordinator.register(this.offer);
      } else {
        this.classList.add('is-selected'); // standalone: always expanded, own button
      }
      this.hideError();
    }

    onToggle() {
      if (this.classList.contains('is-selected') && window.OfferCoordinator.isActive(this.offer)) {
        this.classList.remove('is-selected');
        window.OfferCoordinator.clear(this.offer);
        return;
      }
      this.classList.add('is-selected');
      window.OfferCoordinator.select(this.offer);
    }
    deselectBundle() { this.classList.remove('is-selected'); }
    offerLabel() {
      var p = this.currentPartner();
      var full = this.shirtPrice + (p ? p.price : 0);
      var deal = this.dealCents > 0 ? this.dealCents : full;
      return 'Add bundle · ' + money(deal);
    }

    currentPartner() {
      if (!this.colorSelect) return this.partnerData[0];
      var id = parseInt(this.colorSelect.value, 10);
      return this.partnerData.filter(function (p) { return p.id === id; })[0] || this.partnerData[0];
    }
    set(sel, html) { var el = this.querySelector(sel); if (el) el.innerHTML = html; }

    onColorChange() {
      var p = this.currentPartner();
      if (!p) return;
      if (this.sizeSelect) {
        this.sizeSelect.innerHTML = p.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + v.size + (v.available ? '' : ' — Sold out') + '</option>';
        }).join('');
        var fa = p.variants.filter(function (v) { return v.available; })[0];
        if (fa) this.sizeSelect.value = fa.id;
      }
      if (this.partnerThumb && p.img) this.partnerThumb.src = p.img;
      if (this.partnerName) this.partnerName.textContent = p.name;

      var full = this.shirtPrice + p.price;
      var deal = this.dealCents > 0 ? this.dealCents : full;
      var save = Math.max(0, full - deal);
      var currentDeal = Math.round(this.shirtPrice * deal / full);
      var partnerDeal = deal - currentDeal;

      this.set('[data-current-deal]', money(currentDeal));
      this.set('[data-partner-deal]', money(partnerDeal));
      this.set('[data-partner-was]', money(p.price));
      this.set('[data-bundle-deal]', money(deal));
      if (this.wasEl) this.wasEl.textContent = money(full);
      if (this.saveEl) this.saveEl.textContent = 'Save ' + money(save);
      this.hideError();
    }

    showError() { if (this.errorEl) { this.errorEl.textContent = 'Please select a size'; this.errorEl.hidden = false; } }
    hideError() { if (this.errorEl) this.errorEl.hidden = true; }

    onAdd() {
      var cur = this.currentSize;
      if (!cur || !cur.value || (cur.selectedOptions[0] && cur.selectedOptions[0].disabled)) { this.showError(); return Promise.resolve(); }
      var s = this.sizeSelect;
      if (!s || !s.value || (s.selectedOptions[0] && s.selectedOptions[0].disabled)) { this.showError(); return Promise.resolve(); }

      // Unique id linking the two lines so the cart watcher keeps them in sync.
      var bundleId = 'ctb-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      var dealName = this.getAttribute('data-deal-name') || 'Bundle deal';
      var props = {
        '_bundle_id': bundleId,
        '_bundle_total': String(this.dealCents),
        'Bundle': dealName
      };
      var items = [
        { id: parseInt(cur.value, 10), quantity: 1, properties: props },
        { id: parseInt(s.value, 10), quantity: 1, properties: props }
      ];

      var btn = this.addBtn, label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (x) { return x.section; });
        body.sections_url = window.location.pathname;
      }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) return r.json().then(function (b) { throw new Error(b.description || 'e'); }); return r.json(); })
        .then(function (resp) {
          if (drawer && typeof drawer.renderContents === 'function' && resp.sections) {
            drawer.renderContents(resp);
            if (typeof updateCartCounters === 'function') updateCartCounters();
            btn.disabled = false; btn.textContent = label;
          } else { window.location.href = '/cart'; }
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    }
  }
  customElements.define('bundle-widget', BundleWidget);

  if (!customElements.get('bundle-carousel')) {
    class BundleCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ctb-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ctb-slide]'));
        this.prevBtn = this.querySelector('[data-ctb-prev]');
        this.nextBtn = this.querySelector('[data-ctb-next]');
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-ctb-dot]'));
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.go.bind(this, -1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.go.bind(this, 1));
        this.dots.forEach(function (dot) {
          dot.addEventListener('click', function () { this.scrollTo(parseInt(dot.getAttribute('data-ctb-dot'), 10)); }.bind(this));
        }.bind(this));

        var sync = this.syncFromScroll.bind(this);
        this.track.addEventListener('scroll', function () {
          window.clearTimeout(this._t);
          this._t = window.setTimeout(sync, 80);
        }.bind(this));
        this.update();
      }

      go(dir) { this.scrollTo(this.index + dir); }

      scrollTo(i) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        this.index = i;
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.update();
      }

      syncFromScroll() {
        var center = this.track.scrollLeft + this.track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < this.slides.length; i++) {
          var s = this.slides[i];
          var mid = s.offsetLeft - this.track.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        this.index = best;
        this.update();
      }

      update() {
        this.dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === this.index); }.bind(this));
        if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index === this.slides.length - 1;
      }
    }
    customElements.define('bundle-carousel', BundleCarousel);
  }
})();
